import React from "react";
// import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// import { useHistory } from "react-router";

// Layouts
// import Auth from "layouts/Auth.js";
// import Index from "views/Index.js";

// components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// API
// import { authCekLogin } from "views/auth/login/api/loginAPI";
import ChangePassword from "views/admin/setting/changePassword/ChangePassword";


export default function Setting() {
    
    

    return (
        <>
            <Sidebar />
            <div className="relative md:ml-64 bg-blueGray-100">
                <AdminNavbar />
                {/* Header */}
                <HeaderStats />
                <div className="px-4 md:px-10 mx-auto w-full h-screen -m-24">
                    <Switch>
                        <Route path="/setting/changePassword" exact component={ChangePassword} />
                        <Redirect from="/setting" to="/setting/changePassword" />
                    </Switch>
                <FooterAdmin />
                </div>
            </div>
        </>
    )
    
}